import './index_mWeb.css';
import { View, FlatListAutoHeight, RouteWrapper, EmptyData, Text } from '../../../component';
import { s, vs } from '../../../utilities/scaling_utils';
import FlatList from 'flatlist-react';
import YNAnswerViewMWeb from '../../component/yn_answer_view/index_mWeb';
import { useLink } from 'react-router-stack';
import I18n from '../../../utilities/locale';
import { useSelector } from 'react-redux';
import NavigationHeader from '../../../component/navigation_header';
import ScreenBackgroundWrapper from '../../../component/screen_background_wrapper';

const PreviewAnswerListMWeb = ({ score, finalAnswerList, teamName }: any) => {
  let { language = 'en' } = useSelector((state: any) => state.app);
  const navigate = useLink();

  const renderAnsItem = (item: any) => {
    const { sequence = 0 } = item;
    return (
      <YNAnswerViewMWeb
        key={item.id}
        item={item}
        qNo={sequence}
        editMode={false}
        onChange2x={() => {}}
        onChangeMyAnswer={() => {}}
        language={language}
      />
    );
  };

  const onPressBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const renderWhenEmpty = () => {
    return <EmptyData message={I18n.t('NoAnswerFound')} />;
  };

  const teamNameStyle = {
    color: '#ffce00'
  };

  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        <NavigationHeader onClickBack={onPressBack} title={`Preview Answer `} />

        <View className="previewAnswerList__headerWrapper_mWeb">
          <View className={'previewAnswerList__header_mWeb'}>
            <Text
              style={teamNameStyle}
              className="previewAnswerList__headerTitle_mWeb">{`Username`}</Text>
            <Text style={teamNameStyle} className="previewAnswerList__headerValue_mWeb">
              &nbsp;&nbsp;:&nbsp;&nbsp;{`${teamName}`}
            </Text>
          </View>

          <View className={'previewAnswerList__header_mWeb'}>
            <Text
              style={teamNameStyle}
              className="previewAnswerList__headerTitle_mWeb">{`Total Points`}</Text>
            <Text style={teamNameStyle} className="previewAnswerList__headerValue_mWeb">
              &nbsp;&nbsp;:&nbsp;&nbsp;{`${score}`}
            </Text>
          </View>
        </View>

        <View
          style={{
            flexGrow: 1,
            position: 'relative',
            marginLeft: s(20),
            marginRight: s(20)
          }}>
          <FlatListAutoHeight
            childStyle={{
              paddingBottom: vs(10)
            }}>
            <FlatList
              list={finalAnswerList}
              renderItem={renderAnsItem}
              renderWhenEmpty={renderWhenEmpty}
            />
          </FlatListAutoHeight>
        </View>
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};
export default PreviewAnswerListMWeb;
